export const viguideVersion = '2.57.1';
